module.exports = __webpack_public_path__ + "img/skill_level_1_svg.ee1c08a8.svg";